export class NewsfeedTranslation
{
    id: number;
    locale: string;
    message: string;
    message_preview: string;
    isHtml: boolean = false;

    /**
     * constructor
     *
     * @return void
     */
    public constructor(init?) {
        if (!!init) {
            Object.assign(this, init);

            if (this.message) {
                this.message_preview = this.message.replace(/<.*?>/g, '');
            }

            this.isHtml = !!this.message && this.message?.localeCompare(this.message_preview) != 0;
        }
    }
}
